import controller from './detail-zone.controller';
import template from './detail-zone.view.html';

let DetailZoneComponent = {
  template,
  controller,
  bindings : {
    shCtrl : '<'
  }
};

export default DetailZoneComponent;



/** WEBPACK FOOTER **
 ** C:/xampp/htdocs/payomaro-pay-zone/www/components/pay-zone/detail-zone/detail-zone.component.js
 **/